export default __webpack_public_path__ + "static/compliance.url-567ca8208d3d2be29701901a8848de63.svg";